import { render, staticRenderFns } from "./FmsFollowUpFileDialog.vue?vue&type=template&id=64a51b3e&scoped=true"
import script from "./FmsFollowUpFileDialog.vue?vue&type=script&lang=js"
export * from "./FmsFollowUpFileDialog.vue?vue&type=script&lang=js"
import style0 from "./FmsFollowUpFileDialog.vue?vue&type=style&index=0&id=64a51b3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a51b3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a51b3e')) {
      api.createRecord('64a51b3e', component.options)
    } else {
      api.reload('64a51b3e', component.options)
    }
    module.hot.accept("./FmsFollowUpFileDialog.vue?vue&type=template&id=64a51b3e&scoped=true", function () {
      api.rerender('64a51b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/FmsFollowUpFileDialog.vue"
export default component.exports